<div class="flex flex-col space-y-2 p-4 bg-white shadow-sm rounded">
  <div class="flex flex-row items-center mb-4">
    <span class="text-xl font-bold">Agendamentos</span>
  </div>

  <div class="flex flex-row justify-around space-x-6">

    <!-- Total -->
    <div class="flex flex-col">
      <span class="text-center p-2">Total</span>
      <div class="flex items-center h-96" #graphContainer>
        <ng-container *ngIf="totalChartOptions$ | async as opts">
          <apx-chart class="w-36 h-full"
            [series]="opts.series"
            [chart]="opts.chart"
            [stroke]="opts.stroke"
            [dataLabels]="opts.dataLabels"
            [xaxis]="opts.xaxis"
            [colors]="opts.colors"
            [fill]="opts.fill"
            [yaxis]="opts.yaxis"
            [legend]="opts.legend"
            [grid]="opts.grid">
          </apx-chart>
        </ng-container>
      </div>
    </div>

    <!-- Presencial -->
    <div class="flex flex-col">
      <span class="text-center p-2">Presencial</span>
      <div class="flex items-center h-96">
        <ng-container *ngIf="inPersonChartOptions$ | async as opts">
          <apx-chart class="w-36 h-full"
            [series]="opts.series"
            [chart]="opts.chart"
            [stroke]="opts.stroke"
            [dataLabels]="opts.dataLabels"
            [xaxis]="opts.xaxis"
            [colors]="opts.colors"
            [fill]="opts.fill"
            [yaxis]="opts.yaxis"
            [legend]="opts.legend"
            [grid]="opts.grid">
          </apx-chart>
        </ng-container>
      </div>
    </div>

    <!-- Online -->
    <div class="flex flex-col">
      <span class="text-center p-2">Online</span>
      <div class="flex items-center h-96">
        <ng-container *ngIf="onlineChartOptions$ | async as opts">
          <apx-chart class="w-36 h-full"
            [series]="opts.series"
            [chart]="opts.chart"
            [stroke]="opts.stroke"
            [dataLabels]="opts.dataLabels"
            [xaxis]="opts.xaxis"
            [colors]="opts.colors"
            [fill]="opts.fill"
            [yaxis]="opts.yaxis"
            [legend]="opts.legend"
            [grid]="opts.grid">
          </apx-chart>
        </ng-container>
      </div>
    </div>

    <!-- Tipo de atendimento -->
    <div class="flex flex-col">
      <span class="text-center p-2">Tipo de atendimento</span>
      <div class="flex items-center h-96">
        <ng-container *ngIf="attendanceTypeChartOptions$ | async as opts">
          <apx-chart class="w-100"
            [series]="opts.series"
            [chart]="opts.chart"
            [labels]="opts.labels"
            [legend]="opts.legend"
            [plotOptions]="opts.plotOptions">
          </apx-chart>
        </ng-container>
      </div>
    </div>

    <!-- Tempo médio -->
    <div class="flex flex-col">
      <span class="text-center p-2">Tempo médio de atendimento</span>
      <div class="flex items-center justify-center h-96">
        <div class="flex flex-col space-y-2 items-center">
          <mat-icon svgIcon="heroicons_outline:clock" class="w-12 h-12"></mat-icon>
          <ng-container *ngIf="serviceDuration$ | async as d">
            <span class="text-2xl font-semibold">{{ d.avg | number:'1.0-0' }} min</span>
          </ng-container>
        </div>
      </div>
    </div>

  </div>
</div>
